import { render, staticRenderFns } from "./DisengageApproval.vue?vue&type=template&id=7a98d130&scoped=true"
import script from "./DisengageApproval.vue?vue&type=script&lang=js"
export * from "./DisengageApproval.vue?vue&type=script&lang=js"
import style0 from "./DisengageApproval.vue?vue&type=style&index=0&id=7a98d130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a98d130",
  null
  
)

export default component.exports